import { render, staticRenderFns } from "./enviado.vue?vue&type=template&id=e8157b92&"
import script from "./enviado.vue?vue&type=script&lang=js&"
export * from "./enviado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports